import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SPONSA_CSS } from "./sponsaCSS";
import apisecured from "../../../api/apisecured";
import BaseURL from "../../../api/BaseURL";
import { setToast } from "../../../State/toastSlice";

// Sponsa logo paths
const LOGO_SVG = (
  <svg viewBox="370 475 225 250" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient
        id="saG1"
        gradientUnits="userSpaceOnUse"
        x1="393.67"
        y1="684.95"
        x2="533.85"
        y2="544.05"
      >
        <stop offset="0" stopColor="#EF237C" />
        <stop offset="1" stopColor="#FFD50E" />
      </linearGradient>
      <linearGradient
        id="saG2"
        gradientUnits="userSpaceOnUse"
        x1="440.92"
        y1="745.23"
        x2="552.7"
        y2="633.44"
      >
        <stop offset="0" stopColor="#EF237C" />
        <stop offset="1" stopColor="#FFD50E" />
      </linearGradient>
      <linearGradient
        id="saG3"
        gradientUnits="userSpaceOnUse"
        x1="422.41"
        y1="705.54"
        x2="515.05"
        y2="625.48"
      >
        <stop offset="0" stopColor="#EF237C" />
        <stop offset="1" stopColor="#FFD50E" />
      </linearGradient>
      <linearGradient
        id="saG4"
        gradientUnits="userSpaceOnUse"
        x1="523.51"
        y1="453.91"
        x2="392.39"
        y2="584.13"
      >
        <stop offset="0" stopColor="#00A1FF" />
        <stop offset="1" stopColor="#00FF8F" />
      </linearGradient>
      <linearGradient
        id="saG5"
        gradientUnits="userSpaceOnUse"
        x1="541.26"
        y1="501.88"
        x2="417.71"
        y2="676.55"
      >
        <stop offset="0" stopColor="#00A1FF" />
        <stop offset="1" stopColor="#00FF8F" />
      </linearGradient>
      <linearGradient
        id="saG6"
        gradientUnits="userSpaceOnUse"
        x1="543.31"
        y1="488.63"
        x2="455.67"
        y2="569.01"
      >
        <stop offset="0" stopColor="#00A1FF" />
        <stop offset="1" stopColor="#00FF7B" />
      </linearGradient>
    </defs>
    <path
      fill="url(#saG1)"
      d="M572.12,577.15L407.87,717.12l67.91-186.27h15.84c9.4,0,18.48,1.39,27.04,3.99C541.36,541.72,560.4,557.04,572.12,577.15z"
    />
    <path
      fill="url(#saG2)"
      d="M584.74,623.98c0,0.28,0,0.56-0.01,0.83c-0.45,51.05-41.97,92.3-93.13,92.3h-83.74l164.25-139.97c0.97,1.66,1.89,3.35,2.76,5.08C581.19,594.79,584.74,608.97,584.74,623.98z"
    />
    <path
      fill="url(#saG3)"
      d="M407.87,717.12c6.74-5.95,13.55-11.83,20.32-17.75l20.41-17.64c6.79-5.89,13.64-11.71,20.47-17.57l20.49-17.54l20.57-17.45c6.86-5.81,13.7-11.65,20.59-17.42l20.65-17.35c6.92-5.75,13.8-11.53,20.75-17.24c-6.74,5.95-13.54,11.83-20.31,17.75l-20.41,17.64c-6.79,5.9-13.65,11.71-20.47,17.57l-20.49,17.54l-20.57,17.45c-6.86,5.81-13.7,11.65-20.59,17.42l-20.65,17.35C421.7,705.62,414.81,711.4,407.87,717.12z"
    />
    <path
      fill="url(#saG4)"
      d="M555.4,482.88L391.14,622.85c-0.97-1.66-1.89-3.35-2.76-5.08c-6.31-12.56-9.87-26.74-9.87-41.76c0-0.28,0-0.56,0.01-0.83c0.45-51.05,41.97-92.3,93.13-92.3H555.4z"
    />
    <path
      fill="url(#saG5)"
      d="M555.4,482.88l-67.91,186.27h-15.84c-9.4,0-18.48-1.39-27.04-3.99c-22.72-6.88-41.75-22.2-53.48-42.31L555.4,482.88z"
    />
    <path
      fill="url(#saG6)"
      d="M555.4,482.88c-6.74,5.95-13.55,11.83-20.32,17.75l-20.41,17.64c-6.79,5.89-13.64,11.71-20.47,17.57l-20.49,17.54l-20.57,17.45c-6.86,5.81-13.7,11.65-20.59,17.42l-20.66,17.35c-6.92,5.75-13.8,11.53-20.75,17.24c6.74-5.95,13.54-11.83,20.32-17.75l20.41-17.64c6.79-5.9,13.65-11.71,20.47-17.57l20.49-17.54l20.57-17.45c6.86-5.81,13.7-11.65,20.59-17.42l20.65-17.35C541.57,494.38,548.46,488.6,555.4,482.88z"
    />
  </svg>
);

const PREVIEW_ALERT_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');

  @property --border-angle {
    syntax: '<angle>';
    initial-value: 0deg;
    inherits: false;
  }

  .sponsa-font { font-family: 'DM Sans', sans-serif; }

  .alert-enter {
    animation: alertEntrance 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    pointer-events: auto;
  }
  .alert-exit {
    animation: alertExit 0.6s cubic-bezier(0.7, 0, 0.84, 0) forwards;
  }
  .alert-hidden {
    opacity: 0;
    filter: blur(8px);
    transform: scale(0.85) translateY(30px);
    pointer-events: none;
  }

  @keyframes alertEntrance {
    0%   { opacity:0; filter:blur(8px); transform:scale(0.85) translateY(30px); }
    40%  { opacity:1; filter:blur(0px); }
    70%  { transform:scale(1.02) translateY(-2px); }
    100% { opacity:1; filter:blur(0px); transform:scale(1) translateY(0); }
  }
  @keyframes alertExit {
    0%   { opacity:1; filter:blur(0px); transform:scale(1) translateY(0); }
    100% { opacity:0; filter:blur(12px); transform:scale(0.9) translateY(-40px); }
  }

  .alert-card-border::before {
    content:'';
    position:absolute;
    inset:-2px;
    border-radius:22px;
    padding:2px;
    background: conic-gradient(
      from var(--border-angle),
      #00FF8F 0%, #00A1FF 25%, #a855f7 50%, #f472b6 75%, #00FF8F 100%
    );
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    animation: rotateBorder 3s linear infinite, borderFadeIn 0.5s 0.3s ease forwards;
    opacity: 0;
  }
  @keyframes rotateBorder { to { --border-angle: 360deg; } }
  @keyframes borderFadeIn  { to { opacity: 0.8; } }

  .alert-card-glow::after {
    content:'';
    position:absolute;
    top:-50%; left:-50%;
    width:200%; height:200%;
    background:
      radial-gradient(ellipse at 30% 50%, rgba(0,255,143,0.08) 0%, transparent 50%),
      radial-gradient(ellipse at 70% 50%, rgba(168,85,247,0.06) 0%, transparent 50%);
    pointer-events:none;
    z-index:1;
  }

  .logo-ring-elem {
    position:absolute;
    inset:-4px;
    border-radius:50%;
    border:2px solid transparent;
    background: conic-gradient(from 0deg, #00FF8F, #00A1FF, #a855f7, #f472b6, #fbbf24, #00FF8F) border-box;
    -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    animation: ringPulse 2s ease-in-out infinite, fadeInScale 0.5s 0.2s ease forwards;
    opacity: 0;
  }
  @keyframes ringPulse    { 0%,100%{transform:scale(1);opacity:.7} 50%{transform:scale(1.08);opacity:1} }
  @keyframes fadeInScale  { from{opacity:0;transform:scale(0.5)} to{opacity:0.7;transform:scale(1)} }

  .logo-glow-elem {
    position:absolute;
    inset:-8px;
    border-radius:50%;
    background: radial-gradient(circle, rgba(0,255,143,0.4) 0%, transparent 70%);
    animation: glowPulse 2s 0.4s ease-in-out infinite;
    opacity: 0;
    pointer-events:none;
  }
  @keyframes glowPulse { 0%,100%{opacity:0;transform:scale(0.8)} 50%{opacity:0.6;transform:scale(1.3)} }

  .logo-inner-elem {
    animation: logoReveal 0.6s 0.15s cubic-bezier(0.34,1.56,0.64,1) forwards;
    opacity:0;
    transform: scale(0.5) rotate(-90deg);
  }
  @keyframes logoReveal { to { opacity:1; transform:scale(1) rotate(0deg); } }

  .slide-in-header {
    animation: slideInText 0.5s 0.25s cubic-bezier(0.16,1,0.3,1) forwards;
    opacity:0; transform:translateX(-15px);
  }
  .slide-in-tipper {
    animation: slideInText 0.5s 0.35s cubic-bezier(0.16,1,0.3,1) forwards;
    opacity:0; transform:translateX(-15px);
  }
  .slide-in-amount {
    animation: amountReveal 0.6s 0.45s cubic-bezier(0.34,1.56,0.64,1) forwards;
    opacity:0; transform:translateX(-15px) scale(0.9);
  }
  .slide-in-message {
    animation: slideUpFade 0.5s 0.55s cubic-bezier(0.16,1,0.3,1) forwards;
    opacity:0; transform:translateY(8px);
  }
  .slide-in-goal {
    animation: slideUpFade 0.5s 0.65s cubic-bezier(0.16,1,0.3,1) forwards;
    opacity:0; transform:translateY(8px);
  }
  .slide-in-soundwave {
    animation: slideUpFade 0.4s 0.35s ease forwards;
    opacity:0;
  }
  @keyframes slideInText  { to { opacity:1; transform:translateX(0); } }
  @keyframes amountReveal { to { opacity:1; transform:translateX(0) scale(1); } }
  @keyframes slideUpFade  { to { opacity:1; transform:translateY(0) translateX(0); } }

  .progress-fill {
    height:100%;
    background: linear-gradient(90deg, #00FF8F 0%, #00d977 100%);
    border-radius:3px;
    width:0%;
    position:relative;
    animation: progressGrow 1.2s 0.8s cubic-bezier(0.16,1,0.3,1) forwards;
  }
  .progress-fill::after {
    content:'';
    position:absolute;
    inset:0;
    background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.3) 50%, transparent 100%);
    animation: shimmer 2s 1.5s infinite;
  }
  @keyframes progressGrow { to { width: var(--goal-pct, 27%); } }
  @keyframes shimmer { 0%{transform:translateX(-100%)} 100%{transform:translateX(200%)} }

  .particle-elem {
    position:absolute;
    border-radius:50%;
    opacity:0;
    animation: particleBurst var(--p-dur,1.5s) var(--p-del,0s) cubic-bezier(0.16,1,0.3,1) forwards;
  }
  @keyframes particleBurst {
    0%   { opacity:1; transform:translate(0,0) scale(1); }
    70%  { opacity:0.8; }
    100% { opacity:0; transform:translate(var(--p-x,50px),var(--p-y,-80px)) scale(0); }
  }

  .sparkle-elem {
    position:absolute;
    opacity:0;
    pointer-events:none;
    animation: sparkleAnim var(--s-dur,1s) var(--s-del,0.3s) ease-out forwards;
  }
  @keyframes sparkleAnim {
    0%  { opacity:0; transform:scale(0) rotate(0deg); }
    50% { opacity:1; transform:scale(1) rotate(90deg); }
    100%{ opacity:0; transform:scale(0) rotate(180deg); }
  }

  .wave-bar { width:2px; border-radius:2px; background:#00FF8F; opacity:0.5; }
  .wave-bar:nth-child(1){ height:8px;  animation:wave 0.8s 0.0s  ease-in-out infinite alternate; }
  .wave-bar:nth-child(2){ height:14px; animation:wave 0.8s 0.1s  ease-in-out infinite alternate; }
  .wave-bar:nth-child(3){ height:10px; animation:wave 0.8s 0.2s  ease-in-out infinite alternate; }
  .wave-bar:nth-child(4){ height:16px; animation:wave 0.8s 0.3s  ease-in-out infinite alternate; }
  .wave-bar:nth-child(5){ height:10px; animation:wave 0.8s 0.15s ease-in-out infinite alternate; }
  @keyframes wave { from{transform:scaleY(0.4)} to{transform:scaleY(1)} }

  .msg-overflow::after {
    opacity:1 !important;
  }
  .alert-message-inner {
    font-size:13px;
    color:rgba(255,255,255,0.7);
    line-height:1.5;
    padding:10px 14px;
    background:rgba(255,255,255,0.04);
    border-radius:10px;
    border-left:3px solid #00FF8F;
    max-height:60px;
    overflow:hidden;
    position:relative;
  }
  .alert-message-inner::after {
    content:'';
    position:absolute;
    bottom:0; left:0; right:0;
    height:26px;
    background: linear-gradient(to bottom, transparent, rgba(6,2,40,0.95));
    border-radius:0 0 10px 10px;
    pointer-events:none;
    opacity:0;
    transition:opacity 0.3s ease;
  }
`;

function generateParticleData() {
  const colors = [
    "#00FF8F",
    "#00A1FF",
    "#fbbf24",
    "#f472b6",
    "#a855f7",
    "#ffffff",
  ];

  const count = 18;
  const particles = [];
  const sparkles = [];

  for (let i = 0; i < count; i++) {
    const size = 4 + Math.random() * 8;
    const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.5;
    const distance = 80 + Math.random() * 160;
    const x = Math.cos(angle) * distance;
    const y = Math.sin(angle) * distance - 40;
    const color = colors[i % colors.length];

    particles.push({
      id: `p-${Date.now()}-${i}`,
      size,
      x,
      y,
      color,
      delay: 0.1 + Math.random() * 0.4,
      duration: 1 + Math.random() * 1,
    });
  }

  for (let i = 0; i < 6; i++) {
    const sSize = 10 + Math.random() * 14;
    const sX = -40 + Math.random() * 520;
    const sY = -20 + Math.random() * 200;
    const color = colors[Math.floor(Math.random() * colors.length)];

    sparkles.push({
      id: `s-${Date.now()}-${i}`,
      sSize,
      sX,
      sY,
      color,
      delay: 0.2 + Math.random() * 0.8,
      duration: 0.6 + Math.random() * 0.6,
    });
  }

  return { particles, sparkles };
}

export default function StreamSettingPage() {
  const userlogin = useSelector((state) => state.auth);
  const userUID = userlogin.uid;
  const dispatch = useDispatch();

  const [copied, setCopied] = useState(false);
  const [alertState, setAlertState] = useState("idle"); // idle | active | exiting
  const [pData, setPData] = useState(() => generateParticleData());

  const timerRef = useRef(null);
  const msgRef = useRef(null);

  const previewName = "TestSupporter";
  const previewAmount = `${userlogin.currencySymbol || "£"}10.00`;
  const previewMessage = "Keep up the great content!";
  const previewGoal = "Goal Name";
  const previewGoalPercent = 27;

  const alertUrl = `${BaseURL}/streamalerts?userUID=${userUID}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(alertUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const sendTestAlert = async () => {
    const testAlertData = {
      donorName: previewName,
      amount: 10.0,
      currency: userlogin.currency || "GBP",
      goalTitle: previewGoal,
      message: previewMessage,
      goalPercent: previewGoalPercent,
      goalReceivedAmount: 27,
      goalTotalAmount: 100,
    };

    try {
      const response = await apisecured.post("goals/test-alert", testAlertData);

      if (response.status === 200) {
        dispatch(
          setToast({ message: "Changes saved successfully!", type: "success" }),
        );
      } else {
        dispatch(
          setToast({
            message: `Failed to send test alert: ${response.statusText}`,
            type: "error",
          }),
        );
      }
    } catch (error) {
      console.error("Error sending test alert:", error);
      dispatch(
        setToast({
          message: "Failed to send test alert. Please try again.",
          type: "error",
        }),
      );
    }
  };

  const testAlert = () => {
    if (alertState !== "idle") return;

    clearTimeout(timerRef.current);
    setPData(generateParticleData());
    setAlertState("active");
    sendTestAlert();

    timerRef.current = setTimeout(() => {
      setAlertState("exiting");
      timerRef.current = setTimeout(() => setAlertState("idle"), 650);
    }, 5000);
  };

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  useEffect(() => {
    if (alertState === "active" && msgRef.current) {
      msgRef.current.classList.remove("msg-overflow");

      requestAnimationFrame(() => {
        if (
          msgRef.current &&
          msgRef.current.scrollHeight > msgRef.current.clientHeight + 2
        ) {
          msgRef.current.classList.add("msg-overflow");
        }
      });
    }
  }, [alertState]);

  return (
    <>
      <style>{`${SPONSA_CSS}\n${PREVIEW_ALERT_CSS}`}</style>

      <div className="sp-settings-wrap">
        <div className="sp-settings-inner">
          <header className="page-header">
            <h1 className="page-title">Stream Alerts</h1>
            <p className="page-description">
              Display tip alerts on your stream using a browser source.
            </p>
          </header>

          <section className="settings-section">
            <div className="section-header">
              <div className="section-icon purple">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
              </div>
              <div className="section-title-group">
                <h2 className="section-title">How to Set Up</h2>
                <p className="section-subtitle">
                  Add alerts to OBS, Streamlabs, or any streaming software
                </p>
              </div>
            </div>

            <div className="info-box">
              <p>
                <strong>Step 1:</strong> Copy your unique alert URL below.
              </p>
              <p>
                <strong>Step 2:</strong> In your streaming software, add a new{" "}
                <code>Browser Source</code>.
              </p>
              <p>
                <strong>Step 3:</strong> Paste the URL and set the dimensions to{" "}
                <code>800×600</code> (recommended).
              </p>
              <p>
                <strong>Step 4:</strong> Position the source where you want
                alerts to appear on stream.
              </p>
              <p>
                📖 Need more help?{" "}
                <a
                  href="https://help.sponsa.app/for-creators/4yqnnFziGPBYDwLaFWA41L/adding-live-alerts-to-your-stream/6K6LWoLgssb4caNtsbMSbW"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Read our detailed guide
                </a>
              </p>
            </div>
          </section>

          <section className="settings-section">
            <div className="section-header">
              <div className="section-icon green">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                </svg>
              </div>

              <div className="section-title-group">
                <h2 className="section-title">Your Alert URL</h2>
                <p className="section-subtitle">
                  Keep this URL private — it's unique to your account
                </p>
              </div>
            </div>

            <div className="form-row">
              <label className="form-label">Browser Source URL</label>
              <div className="url-copy-field">
                <div className="url-display font-jetbrains-mono">
                  {alertUrl}
                </div>
                <button
                  className={`copy-btn${copied ? " copied" : ""}`}
                  onClick={handleCopy}
                >
                  {copied ? (
                    <>
                      <svg
                        width="16"
                        height="16"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <polyline points="20 6 9 17 4 12" />
                      </svg>{" "}
                      Copied!
                    </>
                  ) : (
                    <>
                      <svg
                        width="16"
                        height="16"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <rect
                          x="9"
                          y="9"
                          width="13"
                          height="13"
                          rx="2"
                          ry="2"
                        />
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                      </svg>{" "}
                      Copy
                    </>
                  )}
                </button>
              </div>
              <p className="form-help">
                🔗 This URL is unique to your account. Only add it as a browser
                source in your streaming software.
              </p>
            </div>
          </section>

          <section className="settings-section">
            <div className="section-header">
              <div className="section-icon yellow">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  viewBox="0 0 24 24"
                >
                  <path d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </div>
              <div className="section-title-group">
                <h2 className="section-title">Preview</h2>
                <p className="section-subtitle">
                  See what your alerts look like
                </p>
              </div>
            </div>

            <div className="sa-stage">
              <div className="sponsa-font flex items-center justify-center min-h-[320px] bg-transparent overflow-hidden">
                <div
                  className={`relative w-[480px] max-w-[calc(100vw-32px)] ${
                    alertState === "active"
                      ? "alert-enter"
                      : alertState === "exiting"
                        ? "alert-exit"
                        : "alert-hidden"
                  }`}
                  style={{ willChange: "transform, opacity, filter" }}
                >
                  <div className="absolute inset-0 pointer-events-none overflow-visible z-10">
                    {alertState !== "idle" &&
                      pData.particles.map((p) => (
                        <div
                          key={p.id}
                          className="particle-elem"
                          style={{
                            width: p.size,
                            height: p.size,
                            background: p.color,
                            left: "50%",
                            top: "50%",
                            "--p-x": `${p.x}px`,
                            "--p-y": `${p.y}px`,
                            "--p-del": `${p.delay}s`,
                            "--p-dur": `${p.duration}s`,
                            boxShadow: `0 0 ${p.size * 2}px ${p.color}40`,
                          }}
                        />
                      ))}

                    {alertState !== "idle" &&
                      pData.sparkles.map((s) => (
                        <div
                          key={s.id}
                          className="sparkle-elem"
                          style={{
                            left: s.sX,
                            top: s.sY,
                            "--s-del": `${s.delay}s`,
                            "--s-dur": `${s.duration}s`,
                          }}
                        >
                          <svg
                            width={s.sSize}
                            height={s.sSize}
                            viewBox="0 0 24 24"
                            fill={s.color}
                          >
                            <path d="M12 0l2.5 9.5L24 12l-9.5 2.5L12 24l-2.5-9.5L0 12l9.5-2.5z" />
                          </svg>
                        </div>
                      ))}
                  </div>

                  <div
                    className="alert-card-border alert-card-glow relative rounded-[20px] p-6 overflow-hidden backdrop-blur-[20px]"
                    style={{
                      background:
                        "linear-gradient(135deg, rgba(3,0,33,0.95) 0%, rgba(10,5,50,0.95) 100%)",
                      border: "1px solid rgba(255,255,255,0.08)",
                    }}
                  >
                    <div className="relative z-[2] flex gap-[18px] items-start">
                      <div className="flex-shrink-0 w-16 h-16 relative">
                        {alertState !== "idle" && (
                          <div className="logo-glow-elem" />
                        )}
                        {alertState !== "idle" && (
                          <div className="logo-ring-elem" />
                        )}

                        <div
                          className={`w-16 h-16 rounded-full flex items-center justify-center overflow-hidden relative ${
                            alertState !== "idle"
                              ? "logo-inner-elem"
                              : "opacity-0"
                          }`}
                          style={{ background: "#030021" }}
                        >
                          <div className="w-10 h-10">{LOGO_SVG}</div>
                        </div>
                      </div>

                      <div className="flex-1 min-w-0">
                        <div
                          className={`flex items-center gap-2 mb-[6px] ${
                            alertState !== "idle"
                              ? "slide-in-header"
                              : "opacity-0"
                          }`}
                        >
                          <span
                            className="text-[10px] font-bold uppercase tracking-[0.08em] rounded-[6px] px-2 py-[3px] leading-none"
                            style={{ color: "#030021", background: "#00FF8F" }}
                          >
                            NEW TIP
                          </span>

                          <span
                            className="text-[10px] font-medium tracking-[0.04em]"
                            style={{ color: "rgba(255,255,255,0.4)" }}
                          >
                            via{" "}
                            <span style={{ color: "#00FF8F", fontWeight: 600 }}>
                              SPONSA
                            </span>
                          </span>

                          <div
                            className={`flex items-center gap-[2px] ml-auto pl-2 ${
                              alertState !== "idle"
                                ? "slide-in-soundwave"
                                : "opacity-0"
                            }`}
                          >
                            {[0, 1, 2, 3, 4].map((i) => (
                              <div key={i} className="wave-bar" />
                            ))}
                          </div>
                        </div>

                        <div
                          className={`text-[20px] font-bold text-white mb-[2px] leading-[1.2] ${
                            alertState !== "idle"
                              ? "slide-in-tipper"
                              : "opacity-0"
                          }`}
                        >
                          {previewName}
                        </div>

                        <div
                          className={`text-[32px] font-extrabold mb-2 leading-[1.1] ${
                            alertState !== "idle"
                              ? "slide-in-amount"
                              : "opacity-0"
                          }`}
                          style={{
                            background:
                              "linear-gradient(135deg, #00FF8F 0%, #00d977 60%, #00A1FF 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            backgroundClip: "text",
                          }}
                        >
                          {previewAmount}
                        </div>

                        <div
                          className={`${
                            alertState !== "idle"
                              ? "slide-in-message"
                              : "opacity-0"
                          }`}
                        >
                          <div ref={msgRef} className="alert-message-inner">
                            {previewMessage}
                          </div>
                        </div>

                        <div
                          className={`mt-3 ${
                            alertState !== "idle"
                              ? "slide-in-goal"
                              : "opacity-0"
                          }`}
                        >
                          <div className="flex items-center justify-between mb-[6px]">
                            <span
                              className="text-[11px] font-semibold"
                              style={{ color: "#00FF8F" }}
                            >
                              🎯 {previewGoal}
                            </span>
                            <span
                              className="text-[11px] font-semibold"
                              style={{ color: "#00FF8F" }}
                            >
                              → {previewGoalPercent}%
                            </span>
                          </div>

                          <div
                            className="h-[6px] rounded-[3px] overflow-hidden"
                            style={{ background: "rgba(255,255,255,0.06)" }}
                          >
                            {alertState !== "idle" && (
                              <div
                                className="progress-fill"
                                style={{
                                  "--goal-pct": `${previewGoalPercent}%`,
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {alertState === "idle" && (
                <p className="sa-placeholder-text">
                  Click "Test Alert" to preview
                </p>
              )}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 16,
              }}
            >
              <button
                className="btn btn-primary"
                onClick={testAlert}
                disabled={alertState !== "idle"}
              >
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <polygon points="5 3 19 12 5 21 5 3" />
                </svg>
                Test Alert
              </button>
            </div>
          </section>

          <div style={{ height: 80 }} />
        </div>
      </div>
    </>
  );
}
